import { render, staticRenderFns } from "./travelers-details-form.vue?vue&type=template&id=2c383c9f&scoped=true"
import script from "./travelers-details-form.vue?vue&type=script&lang=js"
export * from "./travelers-details-form.vue?vue&type=script&lang=js"
import style0 from "./travelers-details-form.vue?vue&type=style&index=0&id=2c383c9f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c383c9f",
  null
  
)

export default component.exports